export default __webpack_public_path__ + "static/media/download.0f67b97b.svg";